import { Link } from 'react-router-dom';
import { LogoMark } from '../components/LogoMark';

export function NotFoundPage() {
  return (
    <div className="auth-screen">
      <div className="auth-card">
        <LogoMark size={40} />
        <h1>Not found</h1>
        <p className="auth-subtitle">That page doesn't exist, or your role doesn't have access to it.</p>
        <Link to="/" className="btn btn-primary">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
